import {getAppOrigin} from '@salesforce/pwa-kit-react-sdk/utils/url'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {TemplateURL} from 'commerce-sdk-isomorphic'

export const fetchTaxRate = async ({locale, getTokenWhenReady}) => {
    try {
        const appOrigin = getAppOrigin()
        const {commerceAPI} = getConfig().app
        const {parameters, proxyPath} = commerceAPI
        const {siteId} = parameters
        const accessToken = await getTokenWhenReady()
        const contentUrl = new TemplateURL(
            '/custom/headless/v1/organizations/{organizationId}/taxation',
            `${appOrigin}/{proxyPath}`,
            {
                origin: appOrigin,
                pathParams: {...parameters, proxyPath},
                queryParams: {siteId, locale}
            }
        ).toString()
        const response = await fetch(contentUrl, {
            headers: {authorization: `Bearer ${accessToken}`}
        })
        if (!response.ok) {
            throw new Error(`Failed to fetch TaxRate ${response.status} ${response.statusText}`)
        }
        return response.json()
    } catch (err) {
        console.error(err)
        return {}
    }
}
